/*
 * @Author: your name
 * @Date: 2021-02-17 19:57:05
 * @LastEditTime: 2022-11-11 10:17:35
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/getters.js
 */
import { _setProduct, cartLineAmount } from '../modules/store'
import { _numberUpFixed, _phpRound2 } from '@/utils/number'
import { orderFeeChain } from '@/utils/feeChain'
import { deliveryFeeFor } from '@/utils/deliveryFee'

// 配送费：只有外卖单才加（与后端 saveOrderInfo 的 `orderType == 'delivery'` 同一判断）；
// 加多少与购物车报给后端的 details.baseFee 是同一个函数（utils/deliveryFee.js，照后端 getBaseFee 分本地 / 第三方），不取整
function _deliveryBaseFee(state) {
  if (!state.app.isOnline) return 0
  const deliveryInfo = state.contactDetails?.deliveryInfo?.[state.venueId]
  if (deliveryInfo?.orderType !== 'delivery') return 0
  return deliveryFeeFor(state.venueHome.deliverySetting, deliveryInfo)
}

// 多店合单里某一家成员店的费用链（后端对多店不比对金额，这里只管显示与后端逐家复刻一致）
function _subGroupVenueChain(state, getters, venueId, merchantRate) {
  const cartInfo = state.venueHome.subGroupCartList[venueId].cartInfo
  return orderFeeChain({
    subtotal: getters.subGroupCartVenueTotal(venueId),
    surchargeRate: cartInfo?.paymentSurcharge,
    merchantRate
  })
}

export default {
  // Get the total price of goods in the shopping cart
  // 获取购物车里面商品的总价格
  total: (state) => (venueId) => {
    const ls = state.productList.filter(item => item.venueId === venueId)
    const price = ls.reduce((total, prev) => total + cartLineAmount(prev), 0)
    return parseFloat(_numberUpFixed(Number(price)))
  },

  /**
   * sub group cart total product price
   * @param state
   * @param getters
   * @returns {function(*): number}
   */
  subGroupCartTotal: (state, getters) => (venueId) => {
    let price = 0
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          price += getters.subGroupCartVenueTotal(i)
        }
      }
    }
    return parseFloat(_numberUpFixed(Number(price)))
  },

  /**
   * sub group cart individual venue toal
   * @param state
   * @returns {function(*): number}
   */
  subGroupCartVenueTotal: (state) => (venueId) => {
    let price = 0
    if (state.venueHome.subGroupCartList) {
      if (state.venueHome.subGroupCartList[venueId] && state.venueHome.subGroupCartList[venueId].cart) {
        const ls = state.venueHome.subGroupCartList[venueId].cart?.filter(item => item.venueId === venueId)
        price += ls?.reduce((total, prev) => total + cartLineAmount(prev), 0)
      }
    }
    return parseFloat(_numberUpFixed(Number(price)))
  },

  // Public Holiday Surcharge
  // 公共假日附加费
  publicHolidaySurcharge: (state, getters) => (venueId) => {
    // SUR = round(券后小计 × 费率, 2)，与后端落库的 surchargeAmount 同一个数
    return getters._orderFeeChain(venueId).SUR.toFixed(2)
  },

  // 单店费用链（utils/feeChain.js），下面几个显示 / 总额 getter 都从它取，保证行与总额同源
  _orderFeeChain: (state, getters) => (venueId) => {
    return orderFeeChain({
      subtotal: getters.total(venueId),
      discount: state.discountAmount,
      surchargeRate: state.app.paymentSurcharge,
      baseFee: _deliveryBaseFee(state),
      merchantRate: state.app.merchantFee
    })
  },

  // Sub Group Cart Public Holiday Surcharge
  // Sub Group Cart 公共假日附加费
  subGroupCartVenuePublicHolidaySurcharge: (state, getters) => (venueId) => {
    let surchargeFee = 0
    if (state.venueHome.subGroupCartList) {
      if (state.venueHome.subGroupCartList[venueId]) {
        surchargeFee = _subGroupVenueChain(state, getters, venueId, 0).SUR
      }
    }
    return surchargeFee.toFixed(2)
  },

  /**
   * Sub Group Cart Public Holiday Surcharge total
   * @param state
   * @returns {function(*): string}
   */
  subGroupCartPublicHolidaySurchargeTotal: (state, getters) => (venueId) => {
    let surchargeFee = 0
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          // 每家返回的是 toFixed(2) 字符串，先转成数再加（以前 += 字符串会拼成 "01.502.00"）
          surchargeFee += Number(getters.subGroupCartVenuePublicHolidaySurcharge(i))
        }
      }
    }
    return _phpRound2(surchargeFee).toFixed(2)
  },

  // merchantFeePrice
  merchantFeePrice: (state, getters) => (venueId) => {
    // FEE = round((券后小计 + 附加费 + 配送费) × 刷卡费率, 2)
    return getters._orderFeeChain(venueId).FEE
  },

  // sub group cart merchantFeePrice
  subGroupCartMerchantFeePrice: (state, getters) => (venueId) => {
    let merchantFeePrice = 0
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          merchantFeePrice += getters.subGroupCartVenueMerchantFeePrice(i)
        }
      }
    }

    return _phpRound2(merchantFeePrice)
  },

  /**
   * individual venue in sub group cart - merchant fee
   * @param state
   * @returns {function(*): number}
   */
  subGroupCartVenueMerchantFeePrice: (state, getters) => (venueId) => {
    let merchantFeePrice = 0
    if (state.venueHome.subGroupCartList) {
      if (state.venueHome.subGroupCartList[venueId]) {
        // 用这家成员店自己的刷卡费率（与 subGroupCartVenueRealPrice 同源），不是当前正在逛的那家的
        const merchantFee = state.venueHome.subGroupCartList[venueId].cartInfo?.merchantFee ?? 0
        merchantFeePrice = _subGroupVenueChain(state, getters, venueId, merchantFee).FEE
      }
    }
    return merchantFeePrice
  },

  // 刷卡费基数 A4 直接看 _orderFeeChain(venueId).A4。原来的 _beforeDiscountTotal（名不副实，不是「折前」）与
  // 多店的 _subGroupCartVenueBeforeDiscountTotal 都没有调用方，review 第 1 轮 #9 删掉。

  // Amount payable
  // 应付钱数
  realPrice: (state, getters) => (venueId) => {
    // A5 = round(A4 + 刷卡费, 2)：建单请求里报给后端的 amount（后端差 0.1 以上就 ##9## 拒单）
    return getters._orderFeeChain(venueId).A5
  },

  // Subgroup Cart Amount payable
  // 应付钱数
  subGroupCartRealPrice: (state, getters) => (venueId) => {
    let total = 0
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          total += getters.subGroupCartVenueRealPrice(i)
        }
      }
    }
    // 各家已各自取整，求和只去浮点噪声
    return _phpRound2(total)
  },

  subGroupCartVenueRealPrice: (state, getters) => (venueId) => {
    let total = 0
    if (state.venueHome.subGroupCartList) {
      if (state.venueHome.subGroupCartList[venueId]) {
        const merchantFee = state.venueHome.subGroupCartList[venueId].cartInfo?.merchantFee ?? 0
        total = _subGroupVenueChain(state, getters, venueId, merchantFee).A5
      }
    }
    return total
  },

  subGroupCartHasProduct: (state) => () => {
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          const ls = state.venueHome.subGroupCartList[i].cart?.filter(item => item.venueId === i)
          // console.log(ls?.length)
          if (ls && ls.length > 0) {
            return true
          }
        }
      }
    }
    return false
  },

  subGroupCartHasHolidaySurcharge: (state) => () => {
    let surcharge = 0
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          if (state.venueHome.subGroupCartList[i].cartInfo?.paymentSurcharge) {
            surcharge += parseFloat(state.venueHome.subGroupCartList[i].cartInfo.paymentSurcharge)
          }
        }
      }
    }
    return surcharge > 0
  },

  venueSubGroupItemList: (state) => (venueSubGroupId) => {
    const newItemList = {}
    if (state.venueHome.subGroupCartList) {
      for (var i in state.venueHome.subGroupCartList) {
        if (!state.venueHome.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          delete state.venueHome.subGroupCartList[i]
        } else {
          const ls = []
          const res = state.venueHome.subGroupCartList[i].cart?.map(each => {
            return {
              ...each,
              // modifications: each.modifications.filter(e => e.id !== -1 && e.type === 'required')
            }
          })
          if (res) {
            res.forEach(item => {
              if (item.venueId === i) {
                ls.push(_setProduct(item))
              }
            })
          }
          newItemList[i] = {
            ...state.venueHome.subGroupCartList[i],
            cart: ls
          }
        }
      }
    }
    return newItemList
  },

  itemList: (state) => (venueId) => {
    const ls = []
    const res = state.productList.map(each => {
      return {
        ...each,
        // modifications: each.modifications.filter(e => e.id !== -1 && e.type === 'required')
      }
    })
    res.forEach(item => {
      if (item.venueId === venueId) {
        ls.push(_setProduct(item))
      }
    })
    return ls
  },

  tabInfo: (state) => (venueId) => {
    const currentTab = state.tabInfoList.currentTab?.filter(item => item.venueId === venueId)[0] ?? null
    return {
      ...state.tabInfoList,
      currentTab
    }
  }
}
